import {
  ArrowUpIcon,
  Button,
  DollarIcon,
  Heading,
  Pane,
  Popover,
  Position,
  Select,
  Menu,
  Small,
  Strong,
  Text,
  CrossIcon,
  ArrowDownIcon,
  toaster,
} from "evergreen-ui";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getDashboardData, getActivities } from "../external/actions";

import "../styles/dashboard.scss";
import { formatNumberAsCurrency, getCurrency, getCurrentDate } from "../util";
import DoughnutChart from "../../src/components/Dashboard/DoughnutChart";
import LineChart from "../../src/components/Dashboard/LineChart";
import StatsCard from "../../src/components/Dashboard/StatsCard";
import { DatePicker, Space } from "antd";
import BackBar from "../components/backBar";
const { RangePicker } = DatePicker;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.datePickerRef = React.createRef();
    this.state = {
      currency: "INR",
      showDatePicker: false,
      menuBtnTitle: "This Week",
      customStartDate: "",
      customEndDate: "",
      activities: [],
      gtvObjects: [],
      bookingGtv: {},
      bookingCount: {},
      uniqueUsersData: {},
      slotsUtilisationData: {},
      payload: {
        activityId: -1,
        period: 3,
        fromDate: "",
        toDate: "",
      },
    };

    this.handleCustomDateClick = this.handleCustomDateClick.bind(this);
    this.changeMenuBtnTitle = this.changeMenuBtnTitle.bind(this);
    this.getStartEndDate = this.getStartEndDate.bind(this);
    this.populateStatsCard = this.populateStatsCard.bind(this);
    this.populateDcChart = this.populateDcChart.bind(this);
    this.getDataFromActivityId = this.getDataFromActivityId.bind(this);
    this.fetchDashboardData = this.fetchDashboardData.bind(this);
    this.getDataFromActivityId = this.getDataFromActivityId.bind(this);
  }

  async componentDidMount() {
    await this.props.dispatch(getDashboardData(this.state.payload));
    await this.props.dispatch(getActivities());
    console.log(this.props.dashboardData);
    if (this.props.dashboardData?.requestStatus === 1) {
      this.setState((state) => ({
        ...state,
        activities: this.props.activityData.activityDetails,
        gtvObjects: this.props.dashboardData.dashboardDetails.gtvPerDay,
        bookingGtv: this.props.dashboardData.dashboardDetails.bookingGtv,
        bookingCount: this.props.dashboardData.dashboardDetails.bookingCount,
        uniqueUsersData: this.props.dashboardData.dashboardDetails.uniqueUsers,
        slotsUtilisationData:
          this.props.dashboardData.dashboardDetails.slotsUtilisation,
        currency: getCurrency(),
      }));
    }
  }

  async fetchDashboardData(payload) {
    await this.props.dispatch(getDashboardData(payload));

    if (this.props.dashboardData.requestStatus !== 1) {
      toaster.danger("Custom Date limit exceeded!", {
        id: 403,
        description: this.props.dashboardData.message,
      });

      return false;
    }

    this.setState((state) => ({
      ...state,
      gtvObjects: this.props.dashboardData.dashboardDetails.gtvPerDay,
      bookingGtv: this.props.dashboardData.dashboardDetails.bookingGtv,
      bookingCount: this.props.dashboardData.dashboardDetails.bookingCount,
      uniqueUsersData: this.props.dashboardData.dashboardDetails.uniqueUsers,
      slotsUtilisationData:
        this.props.dashboardData.dashboardDetails.slotsUtilisation,
      payload: { ...payload },
    }));
  }

  populateStatsCard() {
    const statsCard = [];
    for (const key in this.state.bookingGtv) {
      statsCard.push(
        <StatsCard
          key={key}
          currency={this.state.currency}
          title={key}
          statsObject={this.state.bookingGtv[key]}
        />
      );
    }

    return statsCard;
  }

  populateDcChart() {
    const dcCharts = [];
    for (const key in this.state.bookingCount) {
      dcCharts.push(
        <DoughnutChart
          key={key}
          currency={this.state.currency}
          title={key}
          dcObject={this.state.bookingCount[key]}
        />
      );
    }

    return dcCharts;
  }

  handleCustomDateClick(close) {
    if (close) close();
    this.setState((state) => ({
      ...state,
      showDatePicker: !state.showDatePicker,
    }));
  }

  changeMenuBtnTitle(title, periodId) {
    this.setState((state) => ({
      ...state,
      menuBtnTitle: title,
    }));

    if (periodId !== -1)
      this.fetchDashboardData({
        ...this.state.payload,
        period: periodId,
      });
  }

  getStartEndDate(value, dateString) {
    this.setState((state) => ({
      ...state,
      customStartDate: dateString[0],
      customEndDate: dateString[1],
    }));

    this.fetchDashboardData({
      ...this.state.payload,
      period: -1,
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  }

  getDataFromActivityId(event) {
    const activityId = parseInt(event.target.value);

    this.fetchDashboardData({
      ...this.state.payload,
      activityId: activityId,
    });
  }

  render() {
    let { currency } = this.state;
    const labels = this.state.gtvObjects.map((value) => value.date);
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      tooltips: {
        backgroundColor: "rgba(15, 77, 136, 0.2)",
        borderRadius: "2px",
        displayColors: false,
        bodyFontSize: 14,
        bodyFontStyle: "medium",
        callbacks: {
          label: function (tooltipItem) {
            //return tooltipItem.xLabel + " : " + tooltipItem.yLabel;
            return formatNumberAsCurrency(currency, tooltipItem.yLabel);
          },
          labelTextColor: function () {
            return "#0F4D88";
          },
          title: function () {
            return;
          },
        },
      },
      scales: {
        yAxes: [
          {
            gridLines: {
              zeroLineColor: "rgba(113, 121, 113, 0.08)",
              color: "rgba(113, 121, 113, 0.08)",
            },
            ticks: {
              fontSize: 10,
              fontColor: "#758a80",
              beginAtZero: true,
              callback: function (value, index, values) {
                return formatNumberAsCurrency(currency, value);
              },
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              zeroLineColor: "rgba(113, 121, 113, 0.08)",
              color: "rgba(113, 121, 113, 0.08)",
            },
            ticks: {
              fontSize: 10,
              fontColor: "#758a80",
            },
          },
        ],
      },
    };
    const data = () => {
      return {
        labels: labels,
        datasets: [
          {
            label: "Dataset",
            tension: 0.3,
            borderColor: "rgb(255, 99, 132)",
            data: this.state.gtvObjects.map((value) => value.gtvValue),
            fill: "start",
            borderColor: "#0F4D88",
            pointRadius: 2,
            backgroundColor: (context) => {
              const ctx = context.chart.ctx;
              const gradient = ctx.createLinearGradient(0, 0, 0, 190);
              gradient.addColorStop(0, "rgba(15, 77, 136, 0.3)");
              gradient.addColorStop(1, "rgba(15, 77, 136, 0)");
              return gradient;
            },
            pointBackgroundColor: "#0F4D88",
            pointBorderColor: "#0F4D88",
            pointHoverBackgroundColor: "white",
            pointHoverBorderColor: "#0F4D88",
            borderWidth: 1.5,
          },
        ],
      };
    };
    return (
      <React.Fragment>
        <BackBar title="Dashboard" />
        <Pane
          display={"flex"}
          width={"100%"}
          paddingLeft={"5%"}
          paddingRight={"5%"}
          flexDirection={"column"}
          marginBottom="40px"
        >
          <Pane
            display={"flex"}
            flexDirection={"column "}
            width="100%"
            marginTop={"20px"}
            justifyContent={"space-between"}
          >
            <Pane
              display={"flex"}
              flexDirection={"row"}
              width="50%"
              justifyContent={"space-between"}
              marginBottom="16px"
              fontSize="20px"
              lineHeight="30px"
              fontWeight="700"
            >
              Dashboard
            </Pane>
            <Pane
              display={"flex"}
              flexDirection={"row "}
              margin={"auto"}
              width="100%"
              justifyContent={"space-between"}
            >
              <Pane width="65%" position={"relative"}>
                <Select
                  width="100%"
                  fontSize="14px"
                  onChange={this.getDataFromActivityId}
                >
                  <option value={-1}>All Activities</option>
                  {this.state.activities.length > 0 ? (
                    this.state.activities.map((value) => (
                      <option key={value.activityId} value={value.activityId}>
                        {value.activityName}
                      </option>
                    ))
                  ) : (
                    <option>Select</option>
                  )}
                </Select>
              </Pane>
              <Pane width="30%" position="relative">
                <Popover
                  content={({ close }) => (
                    <Menu>
                      <Menu.Group>
                        <Menu.Item
                          paddingLeft={-15}
                          paddingTop={10}
                          paddingBottom={10}
                          fontSize={14}
                          lineHeight={20}
                          onClick={() => {
                            close();
                            this.changeMenuBtnTitle("Today", 1);
                            this.setState((state) => ({
                              ...state,
                              showDatePicker: false,
                            }));
                          }}
                        >
                          Today
                        </Menu.Item>
                        <Menu.Item
                          paddingLeft={-15}
                          paddingTop={10}
                          paddingBottom={10}
                          fontSize={14}
                          lineHeight={20}
                          onClick={() => {
                            close();
                            this.changeMenuBtnTitle("Yesterday", 2);
                            this.setState((state) => ({
                              ...state,
                              showDatePicker: false,
                            }));
                          }}
                        >
                          Yesterday
                        </Menu.Item>
                        <Menu.Item
                          paddingLeft={-15}
                          paddingTop={10}
                          paddingBottom={10}
                          fontSize={14}
                          lineHeight={20}
                          onClick={() => {
                            close();
                            this.changeMenuBtnTitle("This Week", 3);
                            this.setState((state) => ({
                              ...state,
                              showDatePicker: false,
                            }));
                          }}
                        >
                          This Week
                        </Menu.Item>
                        <Menu.Item
                          paddingLeft={-15}
                          paddingTop={10}
                          paddingBottom={10}
                          fontSize={14}
                          lineHeight={20}
                          onClick={() => {
                            close();
                            this.changeMenuBtnTitle("This Month", 4);
                            this.setState((state) => ({
                              ...state,
                              showDatePicker: false,
                            }));
                          }}
                        >
                          This Month
                        </Menu.Item>
                      </Menu.Group>
                      <Menu.Divider />
                      <Menu.Group>
                        <Menu.Item
                          paddingLeft={-15}
                          paddingTop={10}
                          paddingBottom={10}
                          fontSize={8}
                          lineHeight={20}
                          onClick={() => {
                            this.handleCustomDateClick(close);
                            this.changeMenuBtnTitle("Custom Date", -1);
                          }}
                        >
                          Custom Date
                        </Menu.Item>
                      </Menu.Group>
                    </Menu>
                  )}
                >
                  <Button width="100%" textAlign="left">
                    {this.state.menuBtnTitle}
                  </Button>
                </Popover>
              </Pane>
            </Pane>
          </Pane>
          <Pane
            display={`${this.state.showDatePicker ? "flex" : "none"}`}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
            marginTop={"16px"}
          >
            <Space direction="vertical" size={12} />
            <RangePicker
              ref={this.datePickerRef}
              onChange={(value, dateString) =>
                this.getStartEndDate(value, dateString)
              }
            />
            <CrossIcon
              size={20}
              height={20}
              width={20}
              onClick={() => this.handleCustomDateClick(false)}
            />
          </Pane>

          {/*  ------------         Line Graph  ------------------  */}

          <Pane
            marginTop={"20px"}
            background="#f1f3f2"
            borderRadius={"10px"}
            width={"100%"}
            padding={"16px"}
            display={"flex"}
            flexDirection="column"
          >
            <Pane display={"flex"} alignItems="center" flexDirection={"row"}>
              <Pane
                height="32px"
                width="32px"
                borderRadius="50%"
                background="#fff"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <DollarIcon color="selected" size={16} />
              </Pane>
              <Text
                marginLeft={"5px"}
                fontSize="14px"
                letterSpacing="0.25px"
                lineHeight="32px"
              >
                Gross Transaction Value (GTV)
              </Text>
            </Pane>

            <Pane
              display="flex"
              flexDirection="column-reverse"
              alignItems="start"
              justifyContent="space-between"
              marginTop={"20px"}
              gap="16px"
            >
              {/*  ------------         Line Chart  ------------------  */}
              <LineChart options={options} data={data} />
              {/*  ------------         Line Graph  ------------------  */}

              <Pane
                display="flex"
                flexDirection="column"
                gap="16px"
                alignItems="center"
                justifyContent="space-between"
                width={"100%"}
              >
                {this.populateStatsCard()}
              </Pane>
            </Pane>
          </Pane>
          <Pane
            justifyContent="space-between"
            flexDirection={"column"}
            display={"flex"}
            marginTop={"20px"}
            width="100%"
            gap="16px"
          >
            {this.populateDcChart()}
          </Pane>

          <Pane
            flexDirection={"column"}
            display={"flex"}
            marginTop={"20px"}
            width={"100%"}
            gap={"16px"}
            paddingBottom={"52px"}
          >
            <Pane
              display="flex"
              justifyContent="space-between"
              flexDirection="row"
              width={"100%"}
              border="default"
              borderRadius={"10px"}
              padding={"20px"}
            >
              <Pane
                display="flex"
                justifyContent="start"
                flexDirection="row"
                width={"100%"}
                alignItems="center"
              >
                <Text fontSize={"16px"} letterSpacing={".25px"}>
                  Unique Users
                </Text>
              </Pane>
              <Pane
                display="flex"
                justifyContent="space-between"
                flexDirection="row"
                alignItems={"center"}
                width={"40%"}
              >
                <Strong
                  size={500}
                  color={"selected"}
                  fontSize={"20px"}
                  fontWeight={"700"}
                  lineHeight={"32px"}
                >
                  {this.state.uniqueUsersData.uniqueUserCount}
                </Strong>
                {this.state.uniqueUsersData.uniqueUserPerc ? (
                  <>
                    {this.state.uniqueUsersData.uniqueUserPerc >= 0 ? (
                      <Pane
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <ArrowUpIcon
                          marginLeft={"10px"}
                          color={"#00B562"}
                          size={14}
                        />
                        <Small marginLeft={"5px"} color={"#00B562"} size={12}>
                          {this.state.uniqueUsersData.uniqueUserPerc}%
                        </Small>
                      </Pane>
                    ) : (
                      <Pane
                        display="flex"
                        justifyContent="spae-between"
                        alignItems="center"
                      >
                        <ArrowDownIcon
                          marginLeft={"10px"}
                          color={"#fe0000"}
                          size={14}
                        />
                        <Small marginLeft={"5px"} color={"#fe0000"} size={12}>
                          {this.state.uniqueUsersData.uniqueUserPerc}%
                        </Small>
                      </Pane>
                    )}
                  </>
                ) : (
                  <Pane>
                    <Small marginLeft={"15px"} color={"#00B562"} size={12}>
                      0%
                    </Small>
                  </Pane>
                )}
              </Pane>
            </Pane>
            {/*  <Pane
              display="flex"
              justifyContent="space-between"
              flexDirection="column"
              background="rgba(15, 77, 136, 0.2)"
              width={"100%"}
              borderRadius="10px"
            >
              <Pane
                display="flex"
                justifyContent="space-between"
                flexDirection="row"
                width={"100%"}
                background={"white"}
                border="default"
                borderRadius={"10px"}
                padding={"20px"}
              >
                <Pane
                  display="flex"
                  justifyContent="start"
                  flexDirection="column"
                  width={"50%"}
                  alignItems="start"
                  gap={"6px"}
                >
                  <Text fontSize={"16px"} letterSpacing={".25px"}>Slots Utilization</Text>
                  <Text fontSize={"12px"} letterSpacing={".25px"}>It represents utilisation for the selected date period.</Text>
                </Pane>
                <Pane
                  display="flex"
                  justifyContent="space-between"
                  flexDirection="row"
                  alignItems={"center"}
                  width={"40%"}
                >
                  <Strong size={500} color={"selected"} fontSize={"20px"} lineHeight={"32px"} fontWeight={"700"}>
                    {
                      this.state.slotsUtilisationData.utilisationPerc ?
                        this.state.slotsUtilisationData.utilisationPerc :
                        0
                    }%
                  </Strong>
                  <Small marginLeft={5} color={"muted"} fontSize={"12px"} letterSpacing={"0.25px"}>
                    {this.state.slotsUtilisationData.usedSlots}
                    /
                    {this.state.slotsUtilisationData.totalSlots} slots
                  </Small>
                </Pane>
              </Pane>
              {/* <Pane display="flex" justifyContent="center" alignItems="center" paddingTop="16px" paddingBottom="16px">
                  <Strong fontSize="16px" color="#043d73" letterSpacing=".25px">See Details</Strong>
                  <ArrowRightIcon size={12} color="#043d73" marginLeft="8px" />
              </Pane>
            </Pane> */}
          </Pane>
        </Pane>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ dashboardData, activityData, authStatus }) => ({
  authStatus,
  dashboardData,
  activityData,
});

export default connect(mapStateToProps)(Dashboard);
